import React from 'react';
import { Container, useTheme, useMediaQuery } from '@mui/material';

import { ZonePolicyOverrideSelection } from '../../../zone-policies/components/shared/zone-policies-override-selection';
import { ViewPropertyContentProps } from '../../types/viewPropertyContentProps';
import { ZonePolicy } from '../../../../../types/generated-types';

export function PropertyZonePolicies({ data }: ViewPropertyContentProps) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  return data ? (
    <Container style={{ marginTop: isSmall ? '16px' : 'null' }}>
      <ZonePolicyOverrideSelection
        returnLabel="Return to Property List"
        returnPath={`/properties`}
        propertyId={data?._id}
        targetPolicyId={data?.zonePolicyId ?? '0'}
        availablePolicies={(data?.assignableZonePolicies as ZonePolicy[]) ?? []}
        value={data?.zonePolicyId ?? '0'}
      />
    </Container>
  ) : null;
}
